.stage-status-hoverview {
    width: 300px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
}
